export default {"src":"/_next/static/media/utp.7b4752b0.svg","height":157,"width":540,"blurWidth":0,"blurHeight":0};